export default __webpack_public_path__ + "static/media/travel-bag-1x.687651b5.webp";